import qs from 'qs';
import { network } from 'services/network';

export const deletePoapView = ({ viewId }: QueryParams) => {
    const querystring = qs.stringify({ viewId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/deletePoapView${querystring}`;

    return network.post(url).then((response) => response.data);
};

export interface QueryParams {
    viewId: number;
}
